export default __webpack_public_path__ + "static/media/logoMB.2f464a47.png";